import { useAppDispatch, useAppSelector } from '@common/hooks'
import Spinner from '@common/widgets/Spinner'
import { fetchApplicationRating } from '@redux/slices/applicationRating'
import { Fragment, useCallback, useEffect, useMemo, useRef } from 'react'

import withReplySection from './ReplySection'
import Review from './Review'
import classNames from './styles.module.scss'


export default function Reviews(): JSX.Element {
  const dispatch = useAppDispatch()
  const applicationRating = useAppSelector(store => store.applicationRating.data)
  const isLoading = useAppSelector(store => store.applicationRating.isLoading)
  const loaderRef = useRef(null)

  const fetchMoreData = useCallback(() => {
    if(!applicationRating || !applicationRating.items.length) {
      return
    }
    const { offset, total, limit } = applicationRating
    if((offset + limit) < total) {
      void dispatch(fetchApplicationRating({ id: applicationRating.app.id, offset: offset + limit }))
    }
  }, [applicationRating])

  const reviewsRender = useMemo(() => {
    if(!applicationRating || !applicationRating.items.length) {
      return null
    }
    const ReviewWithReply = withReplySection(Review)
    return applicationRating.items.map((review, ind) => (
      <Fragment key={review.id}>
        <ReviewWithReply
          {...review}
          mode={ind % 2 ? 'edit' : 'create'}
        />
      </Fragment>
    ))
  }, [applicationRating])

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if(entries[0].isIntersecting) {
        fetchMoreData()
      }
    }, { threshold: 1 })
    if(loaderRef.current) {
      observer.observe(loaderRef.current)
    }
    return () => observer.disconnect()
  }, [fetchMoreData])

  return (
    <>
      <div className={classNames.container}>
        {reviewsRender}
      </div>
      <div ref={loaderRef}>
        {isLoading && reviewsRender?.length && <Spinner className={classNames.spinner}/>}
      </div>
  </>
  )
}
